import { Datatype } from '../../../../expressions/datatype/Datatype';
import { getWidgetFieldDatatypeOptions } from '../../../../expressions/datatype/getWidgetFieldDatatypeOptions';
import {
  IReference,
  ReferenceType,
} from '../../../../expressions/references/IReference';
import { IReferencePath } from '../../../../expressions/references/IReferencePath';
import { ISingleSelectWidget } from './ISingleSelectWidget';

export function getSingleSelectWidgetReference(
  path: IReferencePath,
  widget: ISingleSelectWidget,
): IReference {
  return {
    type: ReferenceType.Widget,
    widgetType: widget.type,
    path,
    id: widget.id,
    code: widget.code,
    label: widget.code,
    field: {
      type: Datatype.String,
      options: getWidgetFieldDatatypeOptions(widget),
    },
  };
}
